import { render, staticRenderFns } from "./BrandsMarketplaceNavigation.vue?vue&type=template&id=5e575d39&scoped=true&"
import script from "./BrandsMarketplaceNavigation.vue?vue&type=script&lang=js&"
export * from "./BrandsMarketplaceNavigation.vue?vue&type=script&lang=js&"
import style0 from "./BrandsMarketplaceNavigation.vue?vue&type=style&index=0&id=5e575d39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e575d39",
  null
  
)

export default component.exports